/* entry: theme */

import './theme.scss';

// Components
import '../../../core/styles/components/info-notice/info-notice';
import '../../../core/styles/components/text/text';

// Sections
import '../../sections/footer/footer';
